import { c as _c } from "react/compiler-runtime";
import { ProfileProxyActionStatus, ProfileProxySide } from "@/entities/IProxy";
import { ApiProfileMin } from "@/generated/models/ApiProfileMin";
import { Tooltip } from "react-tooltip";
const STATUS_CLASSES: Record<ProfileProxyActionStatus, string> = {
  [ProfileProxyActionStatus.ACTIVE]: "tw-text-green tw-bg-green/10 tw-ring-green/20",
  [ProfileProxyActionStatus.REJECTED]: "tw-text-red tw-bg-red/10 tw-ring-red/20",
  [ProfileProxyActionStatus.REVOKED]: "tw-text-red tw-bg-red/10 tw-ring-red/20",
  [ProfileProxyActionStatus.PENDING]: "tw-text-[#FEC84B] tw-bg-[#FEC84B]/10 tw-ring-[#FEC84B]/20"
};
const STATUS_LABELS: Record<ProfileProxySide, Record<ProfileProxyActionStatus, string>> = {
  [ProfileProxySide.GRANTED]: {
    [ProfileProxyActionStatus.ACTIVE]: "Granted",
    [ProfileProxyActionStatus.REJECTED]: "Rejected",
    [ProfileProxyActionStatus.REVOKED]: "Revoked",
    [ProfileProxyActionStatus.PENDING]: "Pending"
  },
  [ProfileProxySide.RECEIVED]: {
    [ProfileProxyActionStatus.ACTIVE]: "Accepted",
    [ProfileProxyActionStatus.REJECTED]: "Rejected",
    [ProfileProxyActionStatus.REVOKED]: "Revoked",
    [ProfileProxyActionStatus.PENDING]: "Pending"
  }
};
export default function ProxyActionRowStatus(t0) {
  const $ = _c(16);
  const {
    status,
    statusOwnerProfile,
    side
  } = t0;
  const t1 = `proxy-status-${statusOwnerProfile.id}`;
  let t2;
  if ($[0] !== statusOwnerProfile.pfp) {
    t2 = statusOwnerProfile.pfp ? <img src={statusOwnerProfile.pfp} alt="Profile picture" className="tw-flex-shrink-0 tw-h-6 tw-w-6 tw-flex-none tw-rounded-lg tw-bg-iron-800 tw-ring-1 tw-ring-white/30" /> : <div className="tw-flex-shrink-0 tw-h-6 tw-w-6 tw-flex-none tw-rounded-lg tw-bg-iron-800 tw-ring-1 tw-ring-white/30" />;
    $[0] = statusOwnerProfile.pfp;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = `${STATUS_CLASSES[status]} tw-text-center tw-rounded-full tw-flex-none tw-py-1 tw-px-2.5 tw-text-xs tw-font-medium tw-ring-1 tw-ring-inset`;
  const t4 = STATUS_LABELS[side][status];
  let t5;
  if ($[2] !== t3 || $[3] !== t4) {
    t5 = <div className={t3}>{t4}</div>;
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t1 || $[6] !== t2 || $[7] !== t5) {
    t6 = <div className="tw-inline-flex tw-space-x-2 lg:tw-min-w-[6.6rem]" data-tooltip-id={t1}>{t2}{t5}</div>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const t7 = `proxy-status-${statusOwnerProfile.id}`;
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      backgroundColor: "#1F2937",
      color: "white",
      padding: "4px 8px"
    };
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== statusOwnerProfile.handle || $[11] !== t7) {
    t9 = <Tooltip id={t7} style={t8}>{statusOwnerProfile.handle}</Tooltip>;
    $[10] = statusOwnerProfile.handle;
    $[11] = t7;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t6 || $[14] !== t9) {
    t10 = <>{t6}{t9}</>;
    $[13] = t6;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  return t10;
}